import React, { useEffect, useContext, useState } from "react";
import BqnContext from "common/BqnContext";
import ActionsContext from "common/ActionsContext";
import styled from "styled-components";
import Modal from "common/Modal";
import TextInput from "common/TextInput";
import Table from "common/graphs/Table/Table";
import ArrangeInColumns from "common/layouts/ArrangeInColumns";

const TableContainer = styled.div`
  position: relative;
  padding: 0;
  td div {
    cursor: pointer;
    display: flex;
    align-items: center;

    i {
      font-size: 20px;
      margin-left: 10px;
    }
  }
  table.MuiTable-root {
    min-width: auto !important;
    max-width: auto !important;
  }
  @media (max-width: 1300px) {
    #table-search {
      width: 120px;
    }
  }
  @media (max-width: 875px) {
    #table-search {
      width: auto;
    }
  }
  & > div > div {
    padding-bottom: 0;
  }
`;

const Wrapper = styled.div`
  background: var(--Background-Block);
  position: relative;
  border-radius: 5px;
  padding: 0;
  .list-hosts {
    overflow: visible;
  }
`;

const ButtonWrapper = styled.div`
  margin-bottom: -40px;
`;

function HostnameModal({ onAppliedChange }) {
  const {
    clusterStatus: { mode },
  } = useContext(BqnContext);
  const [open, setOpen] = useState(false);
  const [bqn, setBqn] = useState("");
  const [hostname, setHostname] = useState("");
  const [errorFooter, setErrorFooter] = useState("");
  const actions = useContext(ActionsContext);
  useEffect(() => {
    return actions.recv("edit-hostname", function (params) {
      const { bqn, hostname } = params;
      setErrorFooter("");
      setBqn(bqn);
      setHostname(hostname);
      setOpen(true);
    });
  }, []);
  if (open === false) {
    return null;
  }

  const doApply = () => {
    const cmd = `system hostname ${hostname}${
      mode === "cluster" ? ` bqn-id ${bqn}` : ""
    }`;
    return ifCl
      .run(cmd)
      .then((response) => {
        if (response.length > 0) {
          throw new Error(response);
        } else {
          onAppliedChange();
          setOpen(false);
        }
      })
      .catch((error) => {
        setErrorFooter(JSON.stringify(error));
      });
  };

  return (
    <Modal
      title={`Edit Hostname${mode === "cluster" ? ` for BQN ${bqn} ` : ""}`}
      superIcon="edit"
      content={() => {
        return (
          <div>
            <TextInput
              name="hostname"
              className="input-group"
              onChange={({ target }) => {
                setHostname(target.value);
              }}
              title="Hostname"
              defaultValue={hostname}
              label="Hostname:"
            />
            <ButtonWrapper className="modal-footer">
              <button
                type="button"
                className="btn btn-link waves-effect"
                onClick={() => doApply()}
              >
                APPLY
              </button>
              <button
                type="button"
                className="btn btn-link waves-effect"
                onClick={() => setOpen(false)}
              >
                CANCEL
              </button>
            </ButtonWrapper>
          </div>
        );
      }}
      applyLabel={null}
      onApply={null}
      closeLabel={null}
      onClose={null}
      footerMessage={
        errorFooter ? (
          <span className="modal-err-msg color-red align-left">
            {errorFooter}
          </span>
        ) : null
      }
    />
  );
}

function SettingsList() {
  const actions = useContext(ActionsContext);
  const [tableData, setTableData] = useState(null);
  const {
    bqnId,
    clusterStatus: { mode },
  } = useContext(BqnContext);
  const isClusterMode = mode === "cluster";

  const doLoad = () => {
    ifCl
      .run("show system hostname detail")
      .then((response) => setTableData(response));
  };

  useEffect(() => {
    doLoad();
  }, []);

  if (!tableData) {
    return null;
  }

  const [header, ...rows] = tableData.trim().split("\n");
  const headerAttrs = header.trim().split(/\s+/);
  const newRows = rows.map((row) => {
    const rowAttrs = row.trim(/\s/).split(/\s+/);
    const newEntry = rowAttrs.reduce((acc, attr, index) => {
      acc[headerAttrs[index]] = attr;
      return acc;
    }, {});
    return newEntry;
  });

  const filteredRows = newRows.filter((row) => {
    if (mode === "standalone" || bqnId === "all") {
      return true;
    }
    return parseFloat(row["BQN"]) === parseFloat(bqnId);
  });

  return (
    <Wrapper>
      <TableContainer isClusterMode={mode === "cluster"}>
        <ArrangeInColumns columns={2} rowGap={0}>
          <Table
            className="list-hosts"
            hasPagination={isClusterMode}
            hasSelectNrRows={isClusterMode}
            isSelectable={false}
            isRowSelectable={false}
            data={filteredRows}
            sort={mode === "cluster"}
            hasColumnFilter={mode === "cluster"}
            columns={[
              ...(mode !== "standalone"
                ? [
                    {
                      label: "BQN",
                      id: "BQN",
                      numeric: true,
                    },
                  ]
                : []),
              {
                label: "HOSTNAME",
                id: "HOSTNAME",
                numeric: false,
              },
              {
                label: "ACTIONS",
                id: "ACTIONS",
                sort: false,
                actions: [
                  {
                    label: "Edit",
                    icon: "edit",
                    onClick: (row) => {
                      actions.send("edit-hostname", {
                        bqn: row["BQN"],
                        hostname: row["HOSTNAME"],
                      });
                    },
                  },
                ],
              },
            ]}
            search={isClusterMode}
            rowsPerPageNr={50}
            exportCSV={false}
          />
        </ArrangeInColumns>
      </TableContainer>
      <HostnameModal onAppliedChange={() => doLoad()} />
    </Wrapper>
  );
}

export default SettingsList;
